/* =========================================================================== *\
 __      __.__     ___________           .__    ____ ________  ________.________
/  \    /  \__| ___\__    ___/___   ____ |  |__/_   /   __   \/   __   \   ____/
\   \/\/   /  |/    \|    |_/ __ \_/ ___\|  |  \|   \____    /\____    /____  \ 
 \        /|  |   |  \    |\  ___/\  \___|   Y  \   |  /    /    /    //       \
  \__/\  / |__|___|  /____| \___  >\___  >___|  /___| /____/    /____//______  /
       \/          \/           \/     \/     \/                             \/ 
\* =========================================================================== */

const ShippingBranchStatus = {
  edit: {
    name: 'เตรียมจัดส่ง',
    color: 'warning',
    icon: 'border_color',
  },
  transport: {
    name: 'จัดส่ง',
    color: 'info',
    icon: 'task_alt',
  },
  receive: {
    name: 'รับเข้า',
    color: 'info',
    icon: 'task_alt',
  },
  success: {
    name: 'รับของครบ',
    color: 'success',
    icon: 'task_alt',
  },
  cancel: {
    name: 'ยกเลิก',
    color: 'error',
    icon: 'cancel',
  },
};

export default ShippingBranchStatus;
